import * as React from 'react';
import { AppState } from '../../../app/state/AppState';
import { ContentTypeFilterAllOption, ContentTypeFilterValue } from '../../models/ContentTypeFilterValue';
import { GenericCard } from './GenericCard';
import { connect } from 'react-redux';
import { ContentDefinitions } from '../../models/contentDefinitions';
import { ContentType } from '../../models/ContentType';
import { SearchResultItem } from '../../models/SearchResultTypes';
import { Messages } from '../../../../gen-src/Localize';
import { AppUrls } from '../../../app/AppUrls';
import { appUrlsSelector } from '../../../app/selectors/AppUrlsSelector';
import { TelemetryService } from '../../services/TelemetryService';

export interface ContentCardWrapperOwnProps {
  readonly content: SearchResultItem;
  readonly itemIndex: number;
  readonly contentType: ContentType;
  readonly row?: number;
  readonly totalCount: number;
  readonly isSelected?: boolean;
}

export type ContentCardWrapperProps = ContentCardWrapperOwnProps & ContentCardWrapperStateProps;

export const ContentCardTestId = `ContentCard`;

export function ContentCardWrapper(props: ContentCardWrapperProps): JSX.Element {
  const ref = React.useRef(null);
  const [isSelected, setIsSelected] = React.useState(false);

  return (
    <div data-tb-test-id={ContentCardTestId} ref={ref}>
      {renderInnerCard(props, isSelected, setIsSelected)}
    </div>
  );
}

ContentCardWrapper.displayName = 'ContentCardWrapper';

function renderInnerCard(
  wrapperProps: ContentCardWrapperProps,
  isSelected: boolean,
  setIsSelected: React.Dispatch<React.SetStateAction<boolean>>
): JSX.Element {
  const cardComponent = ContentDefinitions[wrapperProps.contentType].cardComponent;

  const onResultItemSelected = () => {
    const total =
      wrapperProps.selectedContentTypeFilterValue === ContentTypeFilterAllOption
        ? wrapperProps.totalForMixedContent
        : wrapperProps.totalCount;
    TelemetryService.instance.sendSearchResultClickedEvent({
      type: 'SearchResultClicked',
      eventSource: 'search-space',
      resultType: wrapperProps.contentType.toString() + 's',
      seeAll: false,
      index: wrapperProps.itemIndex + 1, //the rank of the item in the result list starting at 1
      total: total, //the number of results shown
      searchTerm: wrapperProps.searchTerm,
      contentId: wrapperProps.content.id,
    });
    setIsSelected(true);
  };

  let Card;
  if (!cardComponent) {
    Card = GenericCard;
  } else {
    Card = cardComponent;
  }
  if (Card) {
    return <Card {...wrapperProps} onResultItemSelected={onResultItemSelected} isSelected={isSelected} />;
  } else {
    // No card component exists for some content types (e.g. flow output).
    return <div>{Messages.ErrorWithDisplay()}</div>;
  }
}

export interface ContentCardWrapperStateProps {
  readonly selectedContentTypeFilterValue: ContentTypeFilterValue;
  readonly urls: AppUrls;
  readonly searchTerm: string;
  readonly totalForMixedContent: number;
}

const mapStateToProps = (state: AppState) => {
  return {
    selectedContentTypeFilterValue: state.search.selectedContentTypeFilterValue,
    urls: appUrlsSelector(),
    searchTerm: state.search.searchTerm,
    totalForMixedContent: state.search.totalCount,
  };
};

export const ConnectedContentCardWrapper: React.ComponentClass<ContentCardWrapperOwnProps> = connect(mapStateToProps)(ContentCardWrapper);
